export default __webpack_public_path__ + "static/media/calender.6bd56f3b.svg";